var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.536,
    height: 17.914,
    viewBox: "0 0 16.536 17.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok-svgrepo-com_1_",
    "data-name": "tiktok-svgrepo-com (1)",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34582",
    "data-name": "Path 34582",
    d: "M8.2,14.9a2.517,2.517,0,0,1,1.162-1.9,2.758,2.758,0,0,1,2.217-.3V10.367a5.289,5.289,0,0,1,.9.053v2.993a2.756,2.756,0,0,0-2.217.3,2.516,2.516,0,0,0-1.162,1.9,2.675,2.675,0,0,0,.506,1.664q-.155-.08-.316-.181A2.5,2.5,0,0,1,8.2,14.9Zm9.36-8.829a4.03,4.03,0,0,1-1.027-2.021h.853a3.711,3.711,0,0,0,1.07,2.741l.017.018A4.915,4.915,0,0,1,17.564,6.067Zm4.11,2.107v2.932a11.037,11.037,0,0,1-1.894-.248,7.4,7.4,0,0,1-1.848-.726s-.5-.313-.54-.335v6.056a5.869,5.869,0,0,1-.374,1.882,5.672,5.672,0,0,1-1.039,1.645,5.782,5.782,0,0,1-4.255,1.859,5.991,5.991,0,0,1-3.163-.908,6.287,6.287,0,0,1-.9-.726l.007.005a5.992,5.992,0,0,0,3.163.908,5.782,5.782,0,0,0,4.255-1.859,5.662,5.662,0,0,0,1.039-1.645,5.889,5.889,0,0,0,.374-1.882V9.077c.04.022.539.336.539.336a7.392,7.392,0,0,0,1.848.726,11.045,11.045,0,0,0,1.894.248v-2.3A3.016,3.016,0,0,0,21.674,8.174Z",
    transform: "translate(-1.138 -0.325)",
    fill: "#ee1d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34583",
    "data-name": "Path 34583",
    d: "M20.044,8.089v2.3a11.049,11.049,0,0,1-1.894-.248A7.411,7.411,0,0,1,16.3,9.412s-.5-.313-.539-.336v6.056a5.867,5.867,0,0,1-.374,1.882,5.671,5.671,0,0,1-1.039,1.645,5.782,5.782,0,0,1-4.255,1.859,5.992,5.992,0,0,1-3.163-.908l-.007-.005a5.313,5.313,0,0,1-1.291-1.954.008.008,0,0,1,0,0A5.7,5.7,0,0,1,5.3,15.692a5.221,5.221,0,0,1,.684-2.48,5.893,5.893,0,0,1,1.328-1.555,5.6,5.6,0,0,1,1.578-.9,5.491,5.491,0,0,1,1.959-.394v2.325a2.764,2.764,0,0,0-2.217.3A2.431,2.431,0,0,0,8.555,17.1q.161.1.316.181a2.416,2.416,0,0,0,.579.539,2.622,2.622,0,0,0,2.617.239,2.4,2.4,0,0,0,1.351-1.422,3.316,3.316,0,0,0,.139-1.175V4.046H15.8a4.03,4.03,0,0,0,1.027,2.021,4.917,4.917,0,0,0,.913.739,4.763,4.763,0,0,0,1.251.917A5.022,5.022,0,0,0,20.044,8.089Z",
    transform: "translate(-0.403 -0.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34584",
    "data-name": "Path 34584",
    d: "M4.489,22.757v0l.056.151C4.539,22.892,4.518,22.839,4.489,22.757Z",
    transform: "translate(-0.152 -6.144)",
    fill: "#69c9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34585",
    "data-name": "Path 34585",
    d: "M8.487,13.29a5.606,5.606,0,0,0-1.578.9,5.893,5.893,0,0,0-1.328,1.559,5.217,5.217,0,0,0-.684,2.48,5.7,5.7,0,0,0,.333,1.958.008.008,0,0,0,0,0,5.845,5.845,0,0,0,.845,1.469,5.726,5.726,0,0,0,.446.484A6.132,6.132,0,0,1,5.18,20.933a5.764,5.764,0,0,1-.843-1.462.034.034,0,0,1,0,0v0A5.675,5.675,0,0,1,4,17.505a5.221,5.221,0,0,1,.684-2.48,5.886,5.886,0,0,1,1.328-1.559,5.593,5.593,0,0,1,1.578-.9,5.587,5.587,0,0,1,1.113-.313,5.769,5.769,0,0,1,1.741-.025V12.9A5.492,5.492,0,0,0,8.487,13.29Z",
    transform: "translate(0 -2.855)",
    fill: "#69c9d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34586",
    "data-name": "Path 34586",
    d: "M17.415,3.721H15.172V15.137a3.364,3.364,0,0,1-.139,1.175,2.409,2.409,0,0,1-1.351,1.421,2.619,2.619,0,0,1-2.617-.239,2.418,2.418,0,0,1-.581-.537,2.586,2.586,0,0,0,2.3.058,2.407,2.407,0,0,0,1.35-1.422,3.308,3.308,0,0,0,.139-1.175V3h3.1A2.687,2.687,0,0,0,17.415,3.721Zm4.242,3.407v.635A5.023,5.023,0,0,1,20.607,7.4a4.761,4.761,0,0,1-1.251-.917,3.545,3.545,0,0,0,.356.2A4.169,4.169,0,0,0,21.657,7.128Z",
    transform: "translate(-2.017)",
    fill: "#69c9d0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokSvgrepoCom1);
export default __webpack_public_path__ + "static/media/tiktok-svgrepo-com (1).e5edbb73650e0b953012d4f4d691998b.svg";
export { ForwardRef as ReactComponent };